document.addEventListener('algolia.hooks.initialize', function () {

  algoliaShopify.hooks.registerHook("beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      const {
        html,
        item,
        components
      } = templateOptions;
      const itemImage = algoliaShopify.helpers.renderImage(item, 140);
      return html `
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${() => trackSearchAttribution(item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${itemImage.src}"
            srcset="${itemImage.srcset}"
            sizes="${itemImage.sizes}"
            alt="${item.title}"
          />
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentBrand">
            ${item.product_type &&
        components.Highlight({ hit: item, attribute: "product_type" })
        }
           removing vendor
          </div>
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
            </div>
          </div>
          <div class="aa-ItemContentPrice">
            <div class="aa-ItemContentPriceCurrent">
              ${algoliaShopify.helpers.displayPrice(item, distinct)}
            </div>
          </div>
        </div>
      </div>
    </a>
  `;
    }
  );

  //Changement template pour nouveau currentRefinement widget
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
    return html `
      <div class="ais-page">
        <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="clrz-facets-button">
          <div class="ais-facets-button">
            ${window.algolia.show_filters}
          </div>
        </div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container" style="display:none"></div>
          <div class="ais-current-refined-values-container2 t-text"></div>
          ${data.facets.map(
      facet =>
        html`
                <div
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                >
                  <label
                    for="${facet.escapedName}"
                    class="ais-range-slider--header ais-facet--header ais-header"
                    >${facet.title}</label
                  >
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
    )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
        ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
        : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });


  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function (params, facet) {

    if (facet.name === "price_ratio") {
      params = {
        ...params,

        templates: {
          item(item, { html }) {
            const { url, label, count, isRefined, cssClasses } = item;
            return html`
              <label class="${cssClasses.label} flex items-center">
              ${(isRefined? html`
                    <input
                      type="checkbox"
                      class="${cssClasses.checkbox}"
                      checked
                    />
                  `
                : html`
                    <input type="checkbox" class="${cssClasses.checkbox}" />
                  `)}
               
                ${label}
                <span class="${cssClasses.count}" style="top: 3px">${count}</span>
              </label>
            `;
          },
        },
       
        transformItems(items, { results }) {
          const isPromoRefined = results.facets.stats?.price_ratio[0]==-1 || false;

          //il y a un risque de ne pas être exhaustif si bcp de valeurs
          const promoCount = items.reduce((accumulator, currentValue) => {
            return parseFloat(currentValue.value) < 1 ? accumulator+1 : accumulator;
          }, 0)

          //si aucune option promp (pas de valeur < 1)
          if (promoCount === 0) {
            return [];
          }

          return [{
            count: promoCount,
            isRefined: isPromoRefined,
            isExcluded: false,
            value: "-1",
            label: window.algolia.product_promotion
          }]
        },

       
      }
  
    }

    const colorMap = {
      'BLEU': '#0843FF',
      'ROUGE': '#FF0808',
      'NOIR': '#000000',
      'JAUNE': '#F7E800',
      'MARINE': '#043E9F',
      'GRIS': '#C1C1C1',
      'VERT': '#08F50B',
      'KAKI': '#F0E68C',
      'MARRON': '#582900',
      'BEIGE': '#F5F5DC',
      'BORDEAUX': '#800000',
      'BLANC': '#FFFFFF',
      'ROSE': '#FD6C9E',
      'ORANGE': '#FF8000',
      'OR': '#FFD700',
      'BLANCHE/ INDIGO': '#FFFFFF',
      'BLUE/YELLOW': '#0843ff',
      'NOIR/KAKI': '#f0e68c',
      'BLACK/GRAPHITE GREY': '#000000'
    }

    if (facet.name == "meta.filters.color") {
      // Personnalisation des couleurs dans le menu de facettes
      return {
        ...params,
        templates: {
          ...params.templates,
          item(item, {
            html
          }) {
            const {
              label
            } = item;
            const colorBg = colorMap[label] || label;
            const labelHandlelize = label.replace(/[^A-Z0-9]/ig, "");

            return html `
              <label class="ais-RefinementList-label ais-facet--label ais-facet--label-color">
                <div class="ais-facet--label-color-preview ais-facet--label-color-preview--${labelHandlelize}" style="background-color:${colorBg};"></div>
              </label>
            `;
          },
        },
      };
    }

    return {
      ...params
    };
  });

  //Nouveau current Refinement pour prise en charge Promo
  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function () {

    const connectCurrentRefinements =
      window.algoliaShopify.externals.connectors.connectCurrentRefinements;
    const panel = window.algoliaShopify.externals.widgets.panel;


    const createDataAttributes = refinement => {
      return Object.keys(refinement)
        .map(function (key) {
          if (refinement.attribute === "price_ratio" && key == 'value') {
            return `data-${key}="${refinement[key].replace('\\', '')}"`;
          } else {
            return `data-${key}="${encodeURIComponent(refinement[key] || '')}"`;
          }
        })
        .join(' ');
    };
 
    const renderListItem = function (item) {
      const facet = window.algoliaShopify.instantsearch.facets.list.find(function (f) {
        return f.name === item.label;
      });
      const test = item.refinements
        .map(function (refinement) {

          if (facet.name === "price_ratio") {
            return `<li class="ais-current-refined-values--item">
                  <a ${createDataAttributes(refinement)} class="ais-current-refined-values--link">
                    <div class="t-text u-text-13">
                      <div class="ais-current-refined-values--label u-font-bold u-text-orange">
                        ${window.algolia.product_promotion}
                      </div>
                    </div>
                  </a>
                </li>`;
          }

          if (facet.name === "price_range") {
            // Reformater refinement.label pour afficher une fourchette de prix lisible
            const formattedLabel = refinement.label.replace(":", " - ") + " " + window.currency;

            return `<li class="ais-current-refined-values--item">
                  <a ${createDataAttributes(refinement)} class="ais-current-refined-values--link">
                    <div class="t-text u-text-orange u-text-13">
                           <div class="ais-current-refined-values--label u-font-bold ">${
                        facet.title
                      }</div> : ${formattedLabel}
                    </div>
                  </a>
                </li>`;
          }

          return `<li class="ais-current-refined-values--item">
              <a ${createDataAttributes(refinement)} class="ais-current-refined-values--link">
                <div class="t-text u-text-13">
                  <div class="ais-current-refined-values--label">${
                        facet.title
                      }</div>
                      : ${refinement.label}
                </div>
              </a>
            </li>`;
        })
        .join('');

      return test
    };

    const renderCurrentRefinements = function (renderOptions) {
      const items = renderOptions.items;
      const refine = renderOptions.refine;
      const widgetParams = renderOptions.widgetParams;

      widgetParams.container.innerHTML = `
        <div class="ais-current-refined-values--header ais-facet--header ais-header u-w-fit">
          ${algoliaShopify.translations.selectedFilter}
        </div>
        <div class="ais-root ais-current-refined-values ais-facet">
          <ul class="ais-current-refined-values--list">
            ${items.map(renderListItem).join('')}
          </ul>
        </div>`;

      Array.prototype.slice
        .call(
          widgetParams.container.querySelectorAll(
            '.ais-current-refined-values--link'
          )
        )
        .forEach(function (element) {
          element.addEventListener('click', function (event) {
            const item = Object.keys(event.currentTarget.dataset).reduce(function (
              acc,
              key
            ) {
              const itemData = {};
              itemData[key] = decodeURIComponent(
                event.currentTarget.dataset[key]
              );
              return window.algoliaShopify.assign({}, acc, itemData);
            }, {});
          

            refine(item);
          });
        });
    };

    // Create the custom widget
    const customCurrentRefinements = connectCurrentRefinements(
      renderCurrentRefinements
    );

    const hasRefinements = function (helper, facetsList) {

      return facetsList.some(function (f) {
        const isConjunctiveFacetRefined =
          helper.state.isConjunctiveFacet(f.name) &&
          helper.state.isFacetRefined(f.name);
        const isDisjunctiveFacetRefined =
          helper.state.isDisjunctiveFacet(f.name) &&
          helper.state.isDisjunctiveFacetRefined(f.name);
        const isHierarchicalFacetRefined =
          helper.state.isHierarchicalFacet(f.name) &&
          helper.state.isHierarchicalFacetRefined(f.name);

        const numericRefinements = helper.state.getNumericRefinements(f.name);
        const isNumericFacetRefined = Object.keys(numericRefinements).some(
          function (operator) {
            return numericRefinements[operator].length > 0;
          }
        );

        return (
          isNumericFacetRefined ||
          isConjunctiveFacetRefined ||
          isDisjunctiveFacetRefined ||
          isHierarchicalFacetRefined
        );
      });
    };

    const customCurrentRefinementsWithPanel = panel({
      hidden: options => {
        return !hasRefinements(options.helper, window.algoliaShopify.instantsearch.facets.list);
      },
    })(customCurrentRefinements);

    const widget = customCurrentRefinementsWithPanel({
      container: '.ais-current-refined-values-container2'

    });


  const widgetFacetButton = {
        init: () => {
          const $button = document.querySelector('.ais-facets-button');
          $button.addEventListener(
            'click',
            function() {
              const $facets = document.querySelector('.ais-facets');

          if ($facets.classList.contains('ais-facets__shown')) {
            $button.textContent = window.algolia.hide_filters;
          } else {
            $button.textContent = window.algolia.show_filters;
          }
        },
        { passive: true }
      );
    },
  }

    return [widget, widgetFacetButton];

  });

  let productRenderCount = 0;
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components) {
    productRenderCount++;
    const pushes = window.collectionPushes || [];
    const pushHtml = (html, push) => html `
  <div class="push-collection push-collection-${productRenderCount}">
    <article class="c-card-push-collection | u-relative | u-overflow-hidden | u-h-full">
      <figure class="u-relative | u-h-full">
        <picture class="u-w-full u-h-full u-inline-block" >
          <source media="(max-width: 767px)" data-srcset="${push.image_mobile}" srcset="${push.image_mobile}" />
          <source data-srcset="${push.image}" srcset="${push.image}" />
          <img srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="${push.image}" src="${push.image}" class="u-w-full u-h-full u-object-cover lazyload" alt="${push.title}" />
        </picture>
      </figure>
      <header class="u-absolute u-bottom-0 u-left-0 __content u-flex u-items-end u-justify-start u-h-full u-w-full">
        <div class="u-w-full u-p-20">
            ${push.title
        ? html`<h2 class="t-h2 u-mb-0 u-uppercase u-text-white ">${push.title}</h2>`
        : ''}
            
            ${push.subtitle
        ? html`<p class="u-mb-20 u-text-white subtitle">${push.subtitle}</p>`
        : ''}
            
            ${push.url
        ? html`
                  <a href="${push.url}" class="button | u-inline-block | u-extend-href">
                    <span>${push.ctaLabel}</span>
                  </a>
                `
        : ''}
        </div>
      </header>
    </article>
  </div>
`;

    if (productRenderCount === 5 && pushes[0]) {
      return html `${html} ${pushHtml(html, pushes[0])}`;
    }

    if (productRenderCount === 14 && pushes[1]) {
      return html `${html} ${pushHtml(html, pushes[1])}`;
    }

    const hitImage = algoliaShopify.helpers.renderImage(hit, 400);
    return html `
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => trackSearchAttribution(hit)}"
      >
        <div class="u-relative">
          <div
          class="ais-hit--picture-wrapper">
            <div class="u-w-full u-object-cover">
              <img
                class="ais-hit--picture"
                src="${hitImage.src}"
                srcset="${hitImage.srcset}"
                sizes="${hitImage.sizes}"
                alt="${hit.title} - ${hit.variant_title}"
              />
            </div>
          </div>
          ${!hit._distinct && hit.compare_at_price != 0 &&
      html`
                <span class="ais-hit--price-discount u-absolute u-top-10 u-left-10 lg:u-top-15 lg:u-left-15">
                  <span class="t-badge | u-bg-white">${algoliaShopify.helpers.displayDiscount(
        hit.price,
        hit.compare_at_price,
        hit.price_ratio
      )}</span>
                </span>
              `}
        </div>

        <div class="ais-hit--details">
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              data-disctinct="${hit._distinct}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              title="${algoliaShopify.helpers.fullTitle(
        hit.title,
        hit._distinct,
        hit.variant_title
      )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
            </a>
          </p>
          <p class="ais-hit--price">
            <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b> 
            ${hit._distinct && hit.compare_at_price != 0 &&
      html`
                <span class="ais-hit--price-striked"
                  ><span
                    >${algoliaShopify.helpers.displayStrikedPrice(
        hit.price,
        hit.compare_at_price
      )}</span
                  ></span
                >
              `}
          </p>
        </div>
      </div>
    `;
  });

  const loader = document.createElement('div');
  loader.id = 'custom-algolia-loader';
  loader.innerHTML = '<div class="loading-overlay__spinner"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>';
  document.querySelector('.ais-hits-container')?.prepend(loader);

  algolia.hooks.afterRender = function () {
    const existingLoader = document.getElementById('custom-algolia-loader');
    if (existingLoader) {
      existingLoader.remove();
    }
  };
});

